$(function(){
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    $('#contactform').submit(function(e) {
        e.preventDefault();
        $('#errorMsgs').slideUp(function() {
            $(this).html('');
            $('.formrow').removeClass('notValid');
            $('.errorDetailMsg').remove();
            $('input').removeAttr('aria-describedby').removeAttr('aria-invalid');

            var data = {
                firstName: $('#firstName').val(),
                lastName: $('#lastName').val(),
                zip: $('#zip').val(),
                city: $('#city').val(),
                telephone: $('#telephone').val(),
                email: $('#email').val(),
                message: $('#message').val(),
                dataprotection: $('#dataprotection').prop('checked')
            };

            $.post("/scripts/contact/ContactForm.php", data, function (jsonresult) {
                if (jsonresult.status === 'success') {
                    $('#errorMsgs').html(jsonresult.data);
                    if (!!isReduced) {
                        $('#errorMsgs').show();
                        $('#contactform').hide();
                    } else {
                        $('#errorMsgs').slideDown();
                        $('#contactform').slideUp();
                    }
                } else {
                    $('#errorMsgs').html('<h3>Es traten Fehler auf!</h3><p>Bitte kontrollieren Sie alle gekennzeichneten Eingabefelder.</p>');
                    if (!!isReduced) {
                        $('#errorMsgs').show();
                    } else {
                        $('#errorMsgs').slideDown();
                    }

                    var errorFields = jsonresult.data.split('|');

                    var errorMsgs = {
                        'firstName_missing': 'Das Feld "Vorname" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'lastName_missing': 'Das Feld "Nachname" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'zip_missing': 'Das Feld "Postleitzahl" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'city_missing': 'Das Feld "Ort" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'email_missing': 'Das Feld "E-Mail" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'email_Invalid': 'Die angegebene E-Mail-Adresse ist ungültig.',
                        'message_missing': 'Das Feld "Nachricht" ist ein Pflichtfeld und muss ausgefüllt werden.',
                        'dataprotection_missing': 'Die Datenschutzerklärung muss akzeptiert werden.',
                    }

                    for(var i = 0; i < errorFields.length; i++) {
                        let errorFieldTmp = errorFields[i].split('_');
                        let containerID = errorFieldTmp[0];
                        $('#'+containerID)
                            .attr('aria-describedby', containerID+'-error')
                            .attr('aria-invalid', 'true')
                            .closest('.formrow')
                            .addClass('notValid')
                            .append('<p id="'+containerID+'-error" class="errorDetailMsg" role="alert">'+errorMsgs[errorFields[i]]+'</p>');
                        if(i === 0) {
                            $('#'+containerID)
                                .focus();
                        }
                    }
                }
            }, "json");
        });
    });


    $('#loginDlPortal a').click(function (e) {
        e.preventDefault();
        let currentElement = $(this);
        let body = $('body');
        let container = $('#container_loginDlPortal');

        body.toggleClass('loginOpen');
        let isOpen = body.hasClass('loginOpen');

        currentElement.attr('aria-expanded', isOpen.toString());

        if (isReduced) {
            container.toggle();
            if (isOpen) $('#barcode').focus();
        } else {
            container.slideToggle(function () {
                if (isOpen) $('#barcode').focus();
            });
        }
    });


    $('#loginform').submit(function(e) {
        e.preventDefault();

        $('#loginform').removeClass('notValid');
        $('.errorDetailMsg').remove();
        $('#barcode').removeAttr('aria-describedby').removeAttr('aria-invalid');

        $('#loginErrorMsgs').html('');
        $('.formrow').removeClass('notValid');

        var data = {
            barcode: $('#barcode').val(),
            ajax: true
        };

        $.post("/scripts/ajaxDlLogin.php", data, function (jsonresult) {
            if (jsonresult.status === 'success') {
                window.location = "/downloads.php?hash="+jsonresult.hash;
            } else {
                $('#barcode')
                    .focus()
                    .attr('aria-describedby', 'barcode-error')
                    .attr('aria-invalid', 'true')
                    .closest('.inputWrapper')
                    .append('<p id="barcode-error" class="errorDetailMsg" role="alert"><strong>Fehler beim Login:</strong><br /> Ungültiger Barcode eingegeben</p>')
                    .closest('#loginform')
                    .addClass('notValid')
            }
        }, "json");
    });
});